export default __webpack_public_path__ + "static/media/SharePoint.4d7c1187.svg";